import { Calendra2,ExpiryEffectivityDate } from "@common/DatePicker";
import ReactSelect from "@common/ReactSelect";
import { DEFAULT_INPUTFIELD_LENGTH, FIELD_TYPE, REGEX_NUMBER_WITH_TWO_DECIMAL, EFFECTIVITY_EXPIRY_INTERVAL,BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID, SUBTRACT_YEAR, ALLOW_MONTH, LAST_MONTH } from "@src/config/constant";
import React, { useState } from "react";
import bellIcon from '../../styles/webroot/images/bell.png';
import MMVModal from "./MMVModal";
import { getMMVList } from '@src/store/slices/common';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import moment from 'moment';
import ToggleSwitch from "@common/ToggleSwitch";

type EngineCapacityOption = {
    value: number;
    label: string;
};

export default function DynamicFormField(props: any) {
    const [refresh, setRefresh] = useState<any>(1)
    const [showMMVPopup, setShowMMVPopup] = useState(false)
    const [mmvModalType, setMMVModalType] = useState('make')

    const commonState = useSelector((state: any) => state.common)
    // const insuranceState = useSelector((state: any) => state.insurance)

    const pastSixMonths = new Date(new Date().getFullYear(), new Date().getMonth() - 6, new Date().getDate())
    const [minExpiryDate, setMinExpiryDate] = useState(moment().toDate())
    const [maxExpiryDate, setMaxExpiryDate] = useState(moment().add(SUBTRACT_YEAR.ONE, "year").endOf("year").toDate())

    const dispatch: any = useDispatch()

    const getOptionList = (fieldItem: any) => {

    }

    const fetchMMV = async (isfetch = false) => {        
        let vehicleClassification = getFieldItem('vehicle_classification')
        let vehicleUsage = vehicleClassification?.value?.vehicle_usage
        let vehicleType = vehicleClassification?.value?.value

        if (vehicleUsage && vehicleType) {
            let params = { vehicle_usage: vehicleUsage, vehicle_type: vehicleType }
            if (!(commonState?.mmvList?.[params['vehicle_usage']] && Object?.keys(commonState?.mmvList?.[params['vehicle_usage']])?.length) || isfetch) {
                props.setLoading(true)
                dispatch(getMMVList(params)).then((res: any) => props.setLoading(false)).catch((err: any) => props.setLoading(false))
            }
        }
    }

    const setEngineCapacity = (element: any) => {
        const vehicleType = getFieldItem('vehicle_classification')
        if ([BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleType?.value?.value)) {
            const engineCapacity = getFieldItem('engine_capacity')
            if(element.engine_capacity){
                engineCapacity.value = engineCapacity?.options.find((e:EngineCapacityOption) => e.value === element.engine_capacity)
            }else{
                engineCapacity.value = "";
            }
        }
    };

    const isShowDynamicField = (detail: any) => {
        if (detail?.field_show) {
            const splitType = detail.field_show.split('/');
            if (splitType.length > 1) {
                const expectedValues = splitType[1].includes('@') ? splitType[1].split('@') : [splitType[1]];
                const filterFieldItem = props?.fields?.find((each: any) => each.name === splitType[0]);
                const actualValue = String(filterFieldItem?.value?.value ?? filterFieldItem?.value);
                if(expectedValues.includes(actualValue)){
                    return true;
                }
                else return false;
            }
        }
        return !!detail?.['is_show'];
    };

    const isEnable = (fieldItem: any) => {
        return fieldItem.is_enable
    }

    const getFieldValue = (fieldItem: any) => {
        return fieldItem.value || ''
    }

    const onChangeText = (fieldItem: any, text: any) => {
        if (fieldItem && fieldItem.type !== 'tb') {
            if (text) {
                const regex = fieldItem.name !== 'car_fmv' ? REGEX_NUMBER_WITH_TWO_DECIMAL : /^[0-9]+(\.[0-9])?$/
                if (!regex.test(text)) {
                    return
                }
            }
        }
        if (fieldItem.label === 'Customer Name') {
            if (!text || (text && !text.trim())) {
                fieldItem['value'] = ''
            }
        }
        fieldItem['value'] = text
        fieldItem['error_message'] = ''

        // if (fieldItem.name === "car_fmv" && (text.toString().length < 6 || text.toString().length > 9)) {
        //     fieldItem['error_message'] = 'FMV of car must be between 6 to 9 digits';
        // }

        if (['make_name', 'model_name', 'version_name'].includes(fieldItem.name)) {
            setRefresh((prev: any) => prev + 1);
        } else {
            resetChildDependecies(fieldItem)
        }

        if (fieldItem?.name === 'phone' && fieldItem?.value?.length >= 10) {
            props.fetchCustomerData(text)
        }
    }

    const getFieldItem = (key: any) => {
        let filterItem = props?.fields?.filter((item: any) => item.name === key)?.[0]
        return filterItem
    }

    const resetChildDependecies = (fieldItem: any) => {
        let childDependencies: any = fieldItem?.child_depedencies || []

        if (fieldItem.name === 'vehicle_classification') {
            fetchMMV();
            childDependencies = [...childDependencies, 'vehicle'];
        }

        //if autofill status is true, then do not reset below keys
        // if (autoFillStatus) {
        //     childDependencies = childDependencies.filter((key: any) => !preFilledKeys.includes(key))
        // }

        // eslint-disable-next-line
        childDependencies.map((key: any) => {
            let fieldData: any = props?.fields?.filter((fieldData: any) => fieldData.name === key)?.[0]
            if (fieldData) {
                fieldData['error'] = ''
                fieldData['value'] = ''
                if (fieldData.name === "addon_detail") {

                    fieldData['selected_addon'] = []
                    fieldData['original_list'] = []
                    if (props?.resetAddonList) props.resetAddonList()
                }
            }
        })

        setRefresh((prev: any) => prev + 1);
    }


    const onValueSelect = (fieldItem: any, event: any) => {
        
        if (fieldItem.name === 'vehicle') {
            setShowMMVPopup(true)
            return
        }

        if (fieldItem.name === 'make' && event.value === 0) {
            let modelItem = getFieldItem('model')
            modelItem['value'] = event
            modelItem['value_selected'] = event

            let versionItem = getFieldItem('version')
            versionItem['value'] = event
        }
        else if (fieldItem.name === 'model' && event.value === 0) {
            let versionItem = getFieldItem('version')
            versionItem['value'] = event
        }
        
        fieldItem['value'] = event
        fieldItem['error_message'] = ''
        if(fieldItem.name === "vehicle_classification"){
            // When motocycle is seleted reset make_year selection
            const makeYearField = getFieldItem("make_year");
            if (makeYearField) makeYearField.value = "";
    
            // When motocycle is seleted reset engine_capacity selection
            const engineCapacityField = getFieldItem("engine_capacity");
            if (engineCapacityField) engineCapacityField.value = "";

            // When motocycle is seleted reset seat_capacity selection
            const seatingCapacityField = getFieldItem("seat_capacity");
            if (seatingCapacityField) seatingCapacityField.value = "";
            
            if([BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(event.value)){
                props?.SetUpdateMakeYear?.(true);
                // When motocycle is seleted then seating_capacit_field convert into textbox
                if (seatingCapacityField) {
                    seatingCapacityField.type = 'tb';
                    seatingCapacityField.is_enable = false;
                    seatingCapacityField.value = 2;
                }
            }else{
                props?.SetUpdateMakeYear?.(false);
                // When motocycle is seleted then seating_capacit_field convert into dropdown
                if (seatingCapacityField) {
                    seatingCapacityField.type = 'dd';
                    seatingCapacityField.is_enable = true;
                    seatingCapacityField.value = "";
                }
            }
        }

        //store date in string format to prevent redux state error
        if (fieldItem?.name?.includes('date')) {
            fieldItem['value'] = event ? event.toString() : event
        }
        
        if (fieldItem?.name?.includes('date')) {
            if(fieldItem.name === "effectivity_date" || fieldItem.name === "expiry_date" || fieldItem.name === "received_date"){
                if(fieldItem.name === "effectivity_date"){
                    fieldItem['value'] = new Date(event).toLocaleDateString();
                    let expiryDateItem = getFieldItem('expiry_date');
                    if (expiryDateItem) {
                        expiryDateItem.value = '';
                        expiryDateItem.error_message = '';
                        if (props.onValueChange) props.onValueChange(expiryDateItem);
                    }
                    const minExpiry = moment(event).add(EFFECTIVITY_EXPIRY_INTERVAL, 'days').set({ h: 0, m: 0, s: 0 }).toDate()
                    setMinExpiryDate(minExpiry);
                    const maxExpiry = moment(minExpiry)
                        .add(SUBTRACT_YEAR.THREE, 'year')
                        .toDate();
                    setMaxExpiryDate(maxExpiry);
                }
                fieldItem['value'] = new Date(event);
                
            }else{
                fieldItem['value'] = event ? event.toString() : event
            }
        }
        resetChildDependecies(fieldItem)

    }

    const rowClass = (props.rowClass) ? props.rowClass : "col-md-4"

    const expiryDateField = props.fields?.find((item: any) => item.name === "expiry_date");
    const effectivityDateField = props.fields?.find((item: any) => item.name === "effectivity_date");
    const expiryDateValue = expiryDateField?.value;
    let effectivityDateValue = effectivityDateField?.value ? new Date(effectivityDateField.value) : null;

    if (effectivityDateValue) {
        // If time is missing (00:00:00), set the current time
        const now = new Date();
        if (
            effectivityDateValue.getHours() === 0 &&
            effectivityDateValue.getMinutes() === 0 &&
            effectivityDateValue.getSeconds() === 0
        ) {
            effectivityDateValue.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
        }
    } 

     // Effectivity min / max dates
    const effectivityMinDate = moment().subtract(SUBTRACT_YEAR.SIX, "month").toDate();


    const effectivityMaxDate = moment()
        .add(SUBTRACT_YEAR.ONE, "year")
        .toDate();

    const receivedMinDate = moment().subtract(SUBTRACT_YEAR.THREE, "year").toDate()

    const onToggleChange = (fieldItem: any) => {
        fieldItem.value = fieldItem.value === 1 ? 0 : 1;

        fieldItem.error_message = '';

        setRefresh((prev: any) => prev + 1);

        if (props.onValueChange) {
            props.onValueChange(fieldItem);
        }

    }

    return (
        <>
            {
                props?.fields?.map((fieldItem: any, index: number) => {
                    let inputType = 'text'
                    let optionsList = fieldItem?.options?.length ? fieldItem.options : getOptionList(fieldItem)
                    let optionValue = (typeof fieldItem.value === 'object' || fieldItem.type === 'static_info') ? fieldItem.value : (fieldItem.value != 0 || fieldItem.value === 0) ? optionsList?.filter((option: any) => option.value == fieldItem.value)?.[0] : null;   // eslint-disable-line

                    const isShowField = isShowDynamicField(fieldItem)
                    // for both Passenger and Commercial bike option 
                    const isBikeSelected = props.fields?.some(
                        (field: any) =>
                            field.name === "vehicle_classification" &&
                            [BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(field?.value?.value)
                    );
                    
                    // Update make_year options based on bike selection
                    if (fieldItem.name === "make_year") {
                        optionsList = isBikeSelected
                            ? commonState.common['bike_make_year']
                            : commonState.common['make_year'];
                    }
                    
                    switch (fieldItem.type) {
                        case FIELD_TYPE.CURRENCY:
                        case FIELD_TYPE.TELEPHONE:
                        case FIELD_TYPE.SUM:
                        case FIELD_TYPE.TEXT_BOX:
                        case FIELD_TYPE.MOBILE_FIELD:
                            return (
                                isShowField &&
                                <fieldset className={rowClass} key={index}>
                                    <div className="material">
                                        {
                                            isEnable(fieldItem) ?
                                                <input
                                                    maxLength={fieldItem.type === FIELD_TYPE.MOBILE_FIELD ? 10 : DEFAULT_INPUTFIELD_LENGTH}
                                                    disabled={!isEnable(fieldItem)}
                                                    type={inputType}
                                                    placeholder=" "
                                                    name={fieldItem.name}
                                                    className="form-input"
                                                    value={getFieldValue(fieldItem) || ''}
                                                    onChange={(event) => { onChangeText(fieldItem, event.target.value); }}
                                                />
                                                :
                                                <input
                                                    maxLength={fieldItem.type === FIELD_TYPE.MOBILE_FIELD ? 10 : DEFAULT_INPUTFIELD_LENGTH}
                                                    disabled={!isEnable(fieldItem)}
                                                    type={inputType}
                                                    placeholder=" "
                                                    name={fieldItem.name}
                                                    className="form-input"
                                                    value={getFieldValue(fieldItem) || ''}
                                                />
                                        }
                                        <label data-label={fieldItem.label + (fieldItem.is_required ? '*' : ((fieldItem?.conditional_mandatory ? '**' : '')))} className="form-label"></label>

                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            )
                        case FIELD_TYPE.FUTURE_DATE:
                        case FIELD_TYPE.DATE_PICKER: {
                            return (
                                isShowField && 
                                  <fieldset className={"form-filed date-picker-detail " + rowClass} key={index}>
                                    <div className={"material animation-effect" + ((fieldItem.value ) ? ' active-label' : '')}>
                                        {["effectivity_date", "expiry_date", "received_date"].includes(fieldItem.name) ? (
                                            <ExpiryEffectivityDate
                                                onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                                placeholder=""
                                                text={
                                                    fieldItem.name === "effectivity_date"
                                                        ? "Insurance Policy Effectivity Date *"
                                                        : fieldItem.name === "expiry_date"
                                                        ? "Insurance Policy Expiry Date *"
                                                        : `${fieldItem.label} *`
                                                }
                                                insurancePolicyDate={fieldItem?.value}
                                                flag={fieldItem.name}
                                                dateFormat="dd/MM/yyyy"
                                                showTimeSelect={false}
                                                minDate={fieldItem.name === "effectivity_date" ? effectivityMinDate : fieldItem.name === "expiry_date" ? new Date(minExpiryDate) : receivedMinDate}
                                                maxDate={
                                                    fieldItem.name === "effectivity_date" && expiryDateValue && !effectivityDateValue &&
                                                        moment(expiryDateValue).startOf('day').diff(moment().startOf('day').toDate(), 'days') < EFFECTIVITY_EXPIRY_INTERVAL
                                                        ? new Date(0)
                                                        : fieldItem.name === "effectivity_date"
                                                        ? effectivityMaxDate
                                                        : fieldItem.name === "expiry_date"
                                                        ? maxExpiryDate
                                                        : fieldItem.name === "received_date" 
                                                        ? new Date()
                                                        : undefined
                                                }
                                                {...(fieldItem.name === "expiry_date" ? { effectivity_date: effectivityDateValue || new Date() } : {})}
                                                openToDate={fieldItem.name === "expiry_date" ? new Date(minExpiryDate): new Date()}
                                            />
                                        ) : (
                                            <Calendra2
                                                onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                                placeholder={fieldItem.label + (fieldItem.is_required ? '*' : '')}
                                                dateFormat="dd/MM/yyyy"
                                                selected={fieldItem?.value}
                                                fieldId={fieldItem.id}
                                                fields={props?.fields}
                                                fieldLabel={fieldItem.label}
                                                disabled={!fieldItem.is_enable}
                                                apptype={4}
                                                fieldname={fieldItem.name}
                                            />
                                        )}
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            );
                        } 
                        case FIELD_TYPE.DATE_TIME: {
                            return (
                                isShowField &&
                                <fieldset className={"form-filed date-picker-detail " + rowClass} key={index}>
                                    <div className={"material animation-effect" + (fieldItem.value ? ' active-label' : '')}>
                                        <ExpiryEffectivityDate
                                            onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                            placeholder=""
                                            text={fieldItem.label}
                                            insurancePolicyDate={fieldItem?.value}
                                            flag = {fieldItem.name}
                                        />
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>

                                </fieldset>
                            )
                        }
                        // case FIELD_TYPE.CHECK_BOX:
                        //     return (
                        //         <div className="form-filed col-md-11  m-xs-b " key={index}>
                        //             <div className="material">
                        //                 <div className="custom-control custom-checkbox">
                        //                     <input checked={fieldItem.value} id="Individual" type="checkbox" className="custom-control-input " name="Buyer Type" onChange={(e) => {
                        //                         onChangeCheckbox(fieldItem)
                        //                     }} disabled={!fieldItem.is_enable} />
                        //                     <label className="custom-control-label">Same as Current Address </label>
                        //                 </div>

                        //             </div>
                        //         </div>
                        //     )
                        case FIELD_TYPE.RADIO_BOX:
                            return (
                                <div className='form-filed col-md-4 m-xl-b radio-btn existing-loan-fied-radio radio-spacing-wap' key={index + "_radio"}>
                                    <div className='m-lg-r'>
                                        {fieldItem.label}*
                                    </div>
                                    <div className="loan-radio-outer d-flex p-sm-t">
                                    {
                                        fieldItem?.options?.map((option: any, idx: number) => {
                                            return (
                                                
                                                    <div key={idx + "_option"} className="custom-control custom-checkbox col-md-3 col-xs-4 ">
                                                        <input checked={+fieldItem?.value?.value === +option?.value} id={'radio' + option.name + "_" + idx} type="radio" className="custom-control-input" name={'radio' + option.name + "_" + idx} onChange={() => onValueSelect(fieldItem, option)} />
                                                        <label className="custom-control-label">{option.label} </label>
                                                    </div>
                                            )
                                        })
                                    }
                                                </div>

                                    
                                    {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                </div>
                            )

                        case FIELD_TYPE.TEXT_AREA:
                            return (
                                <fieldset className="form-filed col-md-4 textarea-field" key={index}>
                                    <div className={"material"}>
                                        <textarea id="description" placeholder=" " name="notes" className="form-input" value={fieldItem.value} onChange={(e) => {
                                            onValueSelect(fieldItem, e.target.value)
                                        }} />
                                        <label data-label={fieldItem.label} className="form-label"></label>
                                    </div>
                                </fieldset>
                            )
                        case FIELD_TYPE.INFO:
                            return (
                                <fieldset className="form-filed col-md-12" key={index}>
                                    <div className={"material"}>
                                        <div className="info-box customer-detail-bg">
                                            <div className="review-info-icn">
                                            <img src={bellIcon} alt=""/>
                                            </div>
                                            <h4>{fieldItem.value}</h4>
                                        </div>
                                    </div>
                                </fieldset>
                            )
                        case FIELD_TYPE.MMV:
                            return (
                                isShowField &&
                                <fieldset className={rowClass} key={index}>
                                    <div className="material">
                                        {
                                            isEnable(fieldItem) ?
                                                <>
                                                    <input
                                                        maxLength={1000}
                                                        disabled={!isEnable(fieldItem)}
                                                        type={inputType}
                                                        placeholder=" "
                                                        name={fieldItem.name}
                                                        className="form-input"
                                                        value={getFieldValue(fieldItem) || ''}
                                                        onClick={() => setShowMMVPopup(true)}
                                                    />
                                                    <label data-label={fieldItem.label + (fieldItem.is_required ? '*' : '')} className="form-label"></label>
                                                    {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                                </>
                                                : null
                                        }
                                    </div>
                                </fieldset>
                            )

                        // case FIELD_TYPE.MULTI_DROP_DOWN:
                        //     return (
                        //         <fieldset className="multiselect-dropDown col-md-4">
                        //             <div className={((fieldItem.name === 'other_doc' && fieldItem.value.length > 0) || typedValue) ? "active-label material animation-effect" : "material animation-effect "}>
                        //                 <MultiSelect
                        //                     id="other_docs"
                        //                     key={"other_docs"}
                        //                     options={optionsList || []}
                        //                     value={optionValue ?? []}
                        //                     onChange={(e: any) => onValueSelect(fieldItem, e)}
                        //                     isSelectAll={true}
                        //                     placeholder={""}
                        //                     setTypedValue={setTypedValue}
                        //                 />
                        //                 <label data-label={fieldItem.label} className="form-label"></label>

                        //             </div>
                        //         </fieldset>
                        //     )
                        case FIELD_TYPE.SWITCH:
                            return (
                                <fieldset className="form-filed">
                                    <div className="material status-btn">
                                        <div className="status-txt m-sm-r">{fieldItem.label}</div>
                                        <div className='toggle-btn'>
                                            <ToggleSwitch
                                                checked={fieldItem.value === 1}
                                                onChange={() => onToggleChange(fieldItem)}
                                            />
                                        </div>
                                    </div>
                                </fieldset>
                            )

                        default: {
                            return (

                                isShowField &&
                                <React.Fragment key={index} >
                                    {
                                        isEnable(fieldItem) ?
                                            <ReactSelect
                                                options={optionsList}
                                                value={optionValue}
                                                handleChange={(e: any, fieldKey: string) => onValueSelect(fieldItem, e)}
                                                placeholder={fieldItem.label + ((fieldItem.is_required) ? '*' : '')}
                                                fieldKey=""
                                                fieldItemName={fieldItem.name}
                                                isDisabled={!isEnable(fieldItem)}
                                                errorField={fieldItem?.error_message}
                                                fieldSetClassName={"form-filed " + rowClass}

                                            />
                                            :
                                            <ReactSelect
                                                options={optionsList}
                                                value={optionValue}
                                                placeholder={fieldItem.label + ((fieldItem.is_required) ? '*' : '')}
                                                fieldKey=""
                                                isDisabled={!isEnable(fieldItem)}
                                                errorField={fieldItem?.error_message}
                                                fieldSetClassName={"form-filed " + rowClass}
                                            />
                                    }

                                </React.Fragment>
                            )
                        }
                    }
                })
            }
            <MMVModal show={showMMVPopup} type={mmvModalType} handleClose={() => {
                setShowMMVPopup(false)
                setRefresh(!refresh)
            }} vehicleUsage={getFieldItem('vehicle_classification')?.value?.vehicle_usage} setType={setMMVModalType} setEngineCapacity={setEngineCapacity} setFieldItemValue={(value: any) => {
                const oldItem = getFieldItem('vehicle')
                oldItem['value'] = value
            }} />
        </>
    )
}